import { Animation } from '../components/animation'

export function servicesContents() {
    const animation = new Animation;

    const serviceContents = document.querySelectorAll('.js-serviceContents');

    serviceContents.forEach( item => {
        item.addEventListener('click', e => {
            e.preventDefault();

            let block = document.querySelector(item.attributes.href.nodeValue),
                fixidHeight = document.querySelector('[am-fixed]').clientHeight,
                headerHeight = fixidHeight > 125 ? 135 : 115;

            animation.scroll(block, headerHeight, 400);
        });
    });
}